import React from 'react';
import './App.css';

export default class EthPrice extends React.Component {
  render() {
    const { gameCost } = this.props;

    return (
        <div className="eth-price-container">
            <p> Cost per Tile: </p>
            <div>
                <p className="number-readout"> {(gameCost && (gameCost*1).toFixed(3)) || '...'} </p>
            </div>
            <p> ETH </p>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EthPrice.js